import React, { useState, useEffect } from 'react'

export default function ModelOption({ type, selectedManu }) {
	const [modelOptions, setModelOptions] = useState([]);
	//const [isLoaded, setIsLoaded] = useState(false);

	let glassType = "";

	(type === 1) ? glassType = "Glass" : glassType = "MugCup";

	//Fetch model data
	const requestOptions = {
		method: 'GET',
		//method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			//body: JSON.stringify(selectedManu);
		}
	};

	let apiUrl = '/api/WarewashingConfiguration/GetGlasswareModels?manufacturerName=' + selectedManu + '&glassType=' + glassType;

	useEffect(() => {
		fetch(apiUrl, requestOptions)
			.then(response => response.json())
			.then(result => {
				//console.log(result);
				setModelOptions(result);
			});
	}, [selectedManu]);

	return (
		<>
			{modelOptions.map((option, index) => (
				<option
					key={index}
					value={option.Name}
					din={(option.Diameter == null) ? "N/A" : option.Diameter.Inches}
					dcm={(option.Diameter == null) ? "N/A" : option.Diameter.Centimeters}
					hin={(option.Height == null) ? "N/A" : option.Height.Inches}
					hcm={(option.Height == null) ? "N/A" : option.Height.Centimeters}
					diagin={(type === 1 || option.Diagonal == null) ? "N/A" : option.Diagonal.Inches}
					diagcm={(type === 1 || option.Diagonal == null) ? "N/A" : option.Diagonal.Centimeters}
				>
					{option.Name}
				</option>
			))}
		</>
	)
}
